export const usersChatList = [
    {
      id: '100',
      name: 'Mae Jemison',
      picture: '#',
      lastMesssage: 'Hello, Can you help with my order?',
      lastMesssageTime: '09:45 AM'
    },
    {
      id: '200',
      name: 'Ellen Ochoa',
      picture: '#',
      lastMesssage: 'Hello, Can you help with my order?',
      lastMesssageTime: '09:45 AM'
    },
    {
      id: '300',
      name: 'Mae Jemison',
      picture: '#',
      lastMesssage: 'Hello, Can you help with my order?',
      lastMesssageTime: '09:45 AM'
    },
    {
      id: '400',
      name: 'Ellen Ochoa',
      picture: 'https://uploads-ssl.webflow.com/5d7b1b8d1e2e7d7f2f43efd0/6218a0e82a9ba165493a9f22_WhatsApp%20Image%202020-11-11%20at%204.20.26%20PM.jpeg',
      lastMesssage: 'Hello, Can you help with my order?',
      lastMesssageTime: '09:45 AM'
    },
    {
      id: '300',
      name: 'Mae Jemison',
      picture: '#',
      lastMesssage: 'Hello, Can you help with my order?',
      lastMesssageTime: '09:45 AM'
    },
    {
      id: '400',
      name: 'Ellen Ochoa',
      picture: 'https://uploads-ssl.webflow.com/5d7b1b8d1e2e7d7f2f43efd0/6218a0e82a9ba165493a9f22_WhatsApp%20Image%202020-11-11%20at%204.20.26%20PM.jpeg',
      lastMesssage: 'Hello, Can you help with my order?',
      lastMesssageTime: '09:45 AM'
    },
    {
      id: '300',
      name: 'Mae Jemison',
      picture: '#',
      lastMesssage: 'Hello, Can you help with my order?',
      lastMesssageTime: '09:45 AM'
    },
    {
      id: '400',
      name: 'Ellen Ochoa',
      picture: 'https://uploads-ssl.webflow.com/5d7b1b8d1e2e7d7f2f43efd0/6218a0e82a9ba165493a9f22_WhatsApp%20Image%202020-11-11%20at%204.20.26%20PM.jpeg',
      lastMesssage: 'Hello, Can you help with my order?',
      lastMesssageTime: '09:45 AM'
    }
]

export const usersChats = {
  usersDetails: {
    name: 'Mae Jemison',
    picture: '#',
    status: "",
    number: 9867532410,
    tags: [
      {
        name: "Tag1"
      },
      {
        name: "Tag2"
      }
    ],
    lastMesssage: 'Hello, Can you help with my order?',
  },
  messages: [
    {
      lastMesssage: 'Hello, Can you help with my order?',
      lastMesssageTime: '09:45 AM',
      mediaFileLink: "",
      userMessage: true
    },
    {
      lastMesssage: 'Hello, Can you help with my order?',
      lastMesssageTime: '09:45 AM',
      mediaFileLink: "",
      userMessage: false
    }
  ]
}

export const usersChatFilterTags = [
    {
        label: "All",
        count: 0
    },
    {
        label: "Open",
        count: 1250
    },
    {
        label: "Closed",
        count: 500
    },
    {
        label: "Expired",
        count: 5000
    }
]